import React, { useContext, useEffect } from "react";
import {
  Card,
  Col,
  DatePicker,
  Flex,
  InputNumber,
  Modal,
  Row,
  TimePicker,
  Tooltip,
  Typography,
  Upload,
} from "antd";
import { useState } from "react";
import { useRef } from "react";
import { FileAttachment } from "../../../../common/fileAttachment";
import Title from "antd/es/typography/Title";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Select } from "antd";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import {
  DOCUMENT_EXTENSION_ARR,
  IMG_EXTENSION_ARR,
  checkIfFileTypeIsValidForAllAttachment,
  checkIfFileTypeIsValidForImageAttachment,
  checkIfFileTypeIsValidForPdfAttachment,
  dateObjToDispViewDate,
  disableOnWheel,
  downloadUrl,
  formulateAttachmentPreview,
  getPhoneInputFilterOptions,
  readImageFileAsync,
  sanitizeDataTypeClientSide,
  timeObjToDispViewTimeWithSuffix,
  timeWithSuffixToDispViewTime24hFormat,
} from "../../../../../utils/utils";
import {
  fileDocumentUploadAction,
  fileImageUpload,
  fileUploadAction,
} from "../../../../../redux/services/auth/authServices";
import {
  createStaffAction,
  getStaffByIdAction,
  updateStaffAction,
} from "../../../../../redux/services/staff/staffServices";
import {
  ArrowLeftOutlined,
  CameraOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { routes, userRoles } from "../../../../../constants";
import { baseRouteMaker } from "../../../../../constants/routeConsts";
import { getCategoriesSelectListAction } from "../../../../../redux/services/categories/categoriesServices";
import Actions from "../../../../../redux/actions";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { EyeInvisibleOutlined, EyeTwoTone, SearchOutlined, DownOutlined } from "@ant-design/icons";
import { weekDaysData } from "../../../../../constants/data";
import CountryPhoneInput from "antd-country-phone-input";
import {
  allowCharactersOnlyForDecimalNumbers,
  allowCharactersOnlyForIntegerNumbers,
} from "../../../../../utils/appKeyStrokeLimitingUtils";
import "./Staff.scss";
import { toastService } from "../../../../common/toast-messages/toast";
import { InfoButtonIcon } from "../../../../../assets/svg";
import { colors } from "../../../../../constants/colors";
import { appConfig } from "../../../../../constants/config/appConfig";
import { appConstConfig } from "../../../../../constants/config/appConstConfig";
import useLocalStorage from "../../../../../hooks/useLocalStorage";
import { LanguageContext } from "../../../../../context/LanguageProvider";

const StaffForm = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  const { selectedLanguage } = useContext(LanguageContext);

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [imageLoader, setImageLoader] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  const role = Form.useWatch("role", { form, preserve: true });
  const category = Form.useWatch("category", { form, preserve: true });
  const availability = Form.useWatch("availability", { form, preserve: true });
  /* form dependencies */

  /* id dependencies */
  const { selectedStaffId } = useSelector((state) => state.staff);
  /* id dependencies */

  const { userSession, setUserSession } = useLocalStorage(
    appConfig.SESSION_USER_INFO
  );

  /* select list dependencies */
  const [selectedCategory, setSelectedCategory] = useState(null);
  const { categoriesSelectList, subCategoriesSelectList } = useSelector(
    (state) => state.categories
  );
  /* select list dependencies */

  /* module dependencies for attachment - multiple */
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [previewImageSrc, setPreviewImageSrc] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [multipleAttachmentList, setMultipleAttachmentList] = useState([]);
  /* module dependencies for attachment - multiple */

  /* module dependencies for attachment - single */
  const [singleAttachmentObj, setSingleAttachmentObj] = useState(null);
  const [singleAttachmetSelectedImageUrl, setSingleAttachmetSelectedImageUrl] =
    useState("");
  const attachmentRef = useRef(null);
  /* module dependencies for attachment - single */

  /* open image preview for dialog - multiple attachment */
  const handleAttachmentPreview = async (file) => {
    const formulateAttachment = await formulateAttachmentPreview(
      file,
      file?.name,
      file.url
    );
    if (!formulateAttachment?.isFileTypeImage) {
      downloadUrl(formulateAttachment?.fileImagePreview);
    } else {
      if (!file.url && !file.preview) {
        file.preview = await readImageFileAsync(file.originFileObj);
      }
      setPreviewImageSrc(file?.url || file?.preview);
      setOpenPreviewDialog(true);
      const tempPreviewTitle =
        file?.name || file?.url?.substring(file?.url?.lastIndexOf("/") + 1);
      setPreviewTitle(tempPreviewTitle);
    }
  };
  /* open image preview for dialog - multiple attachment */

  /* on Image changed- single attachment */
  const onImageChanged = (e) => {
    const file = e.target.files[0];

    const attachmentFileName = file.name;

    const fileTypeIsValidRes = checkIfFileTypeIsValidForImageAttachment(attachmentFileName);

    if (fileTypeIsValidRes.isValid === false) {
      toastService.error(fileTypeIsValidRes.isInvalidMessage);
    } else {
      setSingleAttachmentObj(file);
      if (file) {
        const formData = new FormData();
        formData.append("image", file);
        let formDataBody = formData;
        setImageLoader(true);
        dispatch(fileImageUpload(formDataBody)).then((apiRes) => {
          const imageUrl = apiRes?.[0];
          setSingleAttachmetSelectedImageUrl(imageUrl);
          setImageLoader(false);
        });
      }
    }
  };
  /* on Image changed- single attachment */

  /* on Category changed */
  const onCategoryChanged = (id, value) => {
    form.resetFields(["subCategories"]);
    if (value && value !== null && value !== undefined) {
      setSelectedCategory(value);
      dispatch(
        Actions.createAction(Actions.GET_SUB_CATEGORIES_SELECT_LIST, {
          subCategoriesSelectList: value?.subcategories,
        })
      );
    }
  };
  /* on Category changed */

  const selectListApiCalls = (details) => {
    // Categories select list
    dispatch(
      getCategoriesSelectListAction(setSelectListLoader, selectedLanguage)
    ).then((apiRes) => {
      const categories = apiRes;
      details &&
        categories &&
        categories?.forEach((element) => {
          if (element._id === details?.categoryInfo?.category?._id) {
            dispatch(
              Actions.createAction(Actions.GET_SUB_CATEGORIES_SELECT_LIST, {
                subCategoriesSelectList: element?.subcategories,
              })
            );
          }
        });
    });
  };
  /* function definition for select list API calls */

  useEffect(() => {
    /* load initial dependencies - Edit */
    if (
      selectedStaffId &&
      selectedStaffId !== "" &&
      selectedStaffId !== null &&
      selectedStaffId !== undefined
    ) {
      const dataToBeSent = {
        selectedStaffId,
      };
      dispatch(getStaffByIdAction(dataToBeSent, navigate, setLoading)).then(
        (apiRes) => {
          const staff = apiRes;

          selectListApiCalls(staff);

          const categoryName =
            selectedLanguage?.value === "ar"
              ? staff?.categoryInfo?.category?.locales[0]?.name
              : staff?.categoryInfo?.category?.name;

          form.setFieldsValue({
            role: staff?.role,
            first_name: staff?.first_name,
            last_name: staff?.last_name,
            email: staff?.email,
            date_of_birth: dayjs(staff?.date_of_birth, "YYYY/MM/DD") || null,
            gender: staff?.gender
              ? { value: staff?.gender, label: staff?.gender }
              : null,
            phone_number: {
              phone: staff?.phone?.phone_number,
              code: Number(staff?.phone?.country_code),
            },
            category: categoryName,
            subCategories: staff?.categoryInfo?.subcategories.map((e) => e._id),
            availability: staff?.availability?.map((element) => ({
              ...element,
              startTime: dayjs(
                timeWithSuffixToDispViewTime24hFormat(element?.startTime),
                "HH:mm"
              ),
              endTime: dayjs(
                timeWithSuffixToDispViewTime24hFormat(element?.endTime),
                "HH:mm"
              ),
            })),
            fees: staff?.fees,
            experience: staff?.experience,
          });
          setSelectedCategory({
            label: categoryName,
            value: staff?.categoryInfo?.category?._id,
          });
          setSingleAttachmetSelectedImageUrl(staff?.profile_image);
          setMultipleAttachmentList(
            staff?.documents?.map((element) => ({
              ...element,
              url: element?.documentUrl,
            }))
          );
        }
      );
    } else {
      /* load initial dependencies - Edit */

      /* load initial dependencies - Add */
      selectListApiCalls(null);
    }
    /* load initial dependencies - Add */
  }, []);

  /* Form submit handler */
  const onSubmit = (values) => {
    const { subCategories, category, phone_number, ...rest } = values;
    // data to be sent during create and update
    const dataToBeSent = {
      ...rest,
      availability: values?.availability?.map(({ _id, ...element }) => ({
        ...element,
        startTime: timeObjToDispViewTimeWithSuffix(element?.startTime),
        endTime: timeObjToDispViewTimeWithSuffix(element?.endTime),
      })),
      gender: !selectedStaffId ? values?.gender : values?.gender?.value,
      date_of_birth:
        dateObjToDispViewDate(values?.date_of_birth, "yyyymmdd") || "",
      profile_image: singleAttachmetSelectedImageUrl,
      documents: multipleAttachmentList?.map((element) => ({
        name: element?.name,
        documentUrl: element?.url,
      })),
      phone: {
        phone_number: values?.phone_number?.phone,
        country_code: values?.phone_number?.code,
      },
      categoryInfo: {
        categoryName: selectedCategory?.label,
        category: selectedCategory?.value,
        subcategories: values?.subCategories,
      },
      password: values?.password,
    };
    // data to be sent during create and update
    console.log(multipleAttachmentList,'multipleAttachmentList');

    if (
      selectedStaffId &&
      selectedStaffId !== "" &&
      selectedStaffId !== null &&
      selectedStaffId !== undefined
    ) {
      const {
        role,
        category,
        subCategories,
        password,
        ...dataToBeSentForEdit
      } = dataToBeSent;

      dataToBeSentForEdit._id = selectedStaffId;
      dispatch(
        updateStaffAction(
          dataToBeSentForEdit,
          navigate,
          setLoading,
          setUserSession
        )
      );
    } else {
      dispatch(
        createStaffAction(dataToBeSent, navigate, setLoading, setUserSession)
      );
    }
  };
  /* Form submit handler */

  const disabledDate = (value) => {
    let eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(new Date().getFullYear() - 18);
    return value > eighteenYearsAgo;
  };

  return (
    <div className="staffListContainer">
      <Flex vertical gap="2rem">
        <Flex gap="1rem">
          <Button
            type="default"
            shape="circle"
            size="small"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(baseRouteMaker(routes.STAFF))}
          />
          <Title level={2}>{`${
            selectedStaffId
              ? t("Modules.Staff.StaffForm.editStaff")
              : t("AppModuleNames.Provider.addStaff")
          }
          `}</Title>
        </Flex>
        <Row justify="start">
          <Col span={12}>
            <Form
              form={form}
              layout="vertical"
              autoComplete="off"
              requiredMark={false}
              style={{ maxWidth: "500px" }}
              initialValues={{ availability: [{}] }}
              onFinish={onSubmit}
            >
              <Flex vertical gap="0.5rem">
                <Form.Item
                  name="role"
                  label={
                    <RequiredLabel
                      text={t("Modules.Configuration.userType")}
                      required={true}
                    />
                  }
                  rules={[
                    {
                      required: true,
                      message: t("Modules.Configuration.pleaseSelectUserType"),
                    },
                  ]}
                >
                  <Select
                    loading={selectListLoader}
                    options={[
                      {
                        value:
                          userRoles.SERVICE_PROVIDER_ADMIN_ROLES.REGULAR_STAFF,
                        label: "Regular Staff",
                      },
                      {
                        value: "medical_staff",
                        label: "Medical Staff",
                      },
                      {
                        value: userRoles.SERVICE_PROVIDER_ADMIN_ROLES.DOCTOR,
                        label: "Doctor",
                      },
                    ]}
                    placeholder={t("Modules.Configuration.selectUserType")}
                    onChange={() => setMultipleAttachmentList([])}
                    disabled={
                      selectedStaffId &&
                      selectedStaffId !== "" &&
                      selectedStaffId !== null &&
                      selectedStaffId !== undefined
                    }
                  />
                </Form.Item>

                <Form.Item
                  label={
                    <RequiredLabel
                      text={t("Modules.Staff.StaffForm.firstName")}
                      required={true}
                    />
                  }
                  name="first_name"
                  rules={[
                    {
                      required: true,
                      message: t(
                        "Modules.Staff.StaffForm.pleaseEnterFirstName"
                      ),
                    },
                    {
                      whitespace: true,
                      message: t(
                        "Modules.Staff.StaffForm.pleaseEnterFirstName"
                      ),
                    },
                  ]}
                  normalize={(value) => sanitizeDataTypeClientSide(value)}
                >
                  <Input
                    placeholder={t("Modules.Staff.StaffForm.enterFirstName")}
                  />
                </Form.Item>

                <Form.Item
                  label={
                    <RequiredLabel
                      text={t("Modules.Staff.StaffForm.lastName")}
                      required={true}
                    />
                  }
                  name="last_name"
                  rules={[
                    {
                      required: true,
                      message: t("Modules.Staff.StaffForm.pleaseEnterLastName"),
                    },
                    {
                      whitespace: true,
                      message: t("Modules.Staff.StaffForm.pleaseEnterLastName"),
                    },
                  ]}
                  normalize={(value) => sanitizeDataTypeClientSide(value)}
                >
                  <Input
                    placeholder={t("Modules.Staff.StaffForm.enterLastName")}
                  />
                </Form.Item>

                <Form.Item
                  label={
                    <RequiredLabel
                      text={t("Modules.Staff.StaffForm.emailAddress")}
                      required={true}
                    />
                  }
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: t(
                        "Modules.Staff.StaffForm.pleaseEnterEmailAddress"
                      ),
                    },
                    {
                      whitespace: true,
                      type: "email",
                      message: t(
                        "Modules.Staff.StaffForm.pleaseEnterValidEmailAddress"
                      ),
                    },
                  ]}
                  normalize={(value) => sanitizeDataTypeClientSide(value)}
                >
                  <Input
                    placeholder={t("Modules.Staff.StaffForm.enterEmailAddress")}
                  />
                </Form.Item>

                <Form.Item
                  initialValue={{
                    code: 971,
                  }}
                  label={
                    <RequiredLabel
                      text={t("SignUp.phoneNumberLabel")}
                      required={true}
                    />
                  }
                  name="phone_number"
                  rules={[
                    {
                      required: true,
                      validator: async (_, value) => {
                        if (value && !value.phone)
                          return Promise.reject(
                            t("SignUp.phoneNumberErrorMessage")
                          );
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <CountryPhoneInput
                    selectProps={{
                      filterOption: (input, option) =>
                        getPhoneInputFilterOptions(input, option),
                    }}
                    maxLength={15}
                    onKeyDown={(e) => allowCharactersOnlyForIntegerNumbers(e)}
                    inline
                  />
                </Form.Item>

                <Form.Item
                  label={
                    <RequiredLabel
                      text={t("Modules.Staff.StaffForm.dateOfBirth")}
                      required={true}
                    />
                  }
                  name="date_of_birth"
                  rules={[
                    {
                      required: true,
                      message: t(
                        "Modules.Staff.StaffForm.pleaseSelectDateOfBirth"
                      ),
                    },
                  ]}
                >
                  <DatePicker
                    onKeyDown={(e) => e.preventDefault()}
                    style={{ width: "100%" }}
                    placeholder={t("Modules.Staff.StaffForm.selectDateOfBirth")}
                    disabledDate={disabledDate}
                    format={"DD-MM-YYYY"}
                  />
                </Form.Item>

                <Form.Item
                  name="gender"
                  label={
                    <RequiredLabel
                      text={t("Modules.Staff.StaffForm.gender")}
                      required={false}
                    />
                  }
                  rules={[
                    {
                      required: true,
                      message: t("Modules.Staff.StaffForm.pleaseSelectGender"),
                    },
                  ]}
                >
                  <Select
                    options={[
                      {
                        label: "Male",
                        value: "Male",
                      },
                      {
                        label: "Female",
                        value: "Female",
                      },
                    ]}
                    placeholder={t("Modules.Staff.StaffForm.selectGender")}
                  />
                </Form.Item>

                {/* form multiple list - availability */}
                <Form.List name="availability">
                  {(fields, { add, remove }) => (
                    <>
                      <Form.Item>
                        <Flex justify="space-between">
                          <Title level={3}>{t("addavailability")}</Title>
                          <Button
                            type="primary"
                            shape="circle"
                            size="small"
                            icon={<PlusOutlined />}
                            disabled={fields?.length === 7}
                            onClick={() => add()}
                          />
                        </Flex>
                      </Form.Item>
                      <div
                        style={{
                          display: "flex",
                          rowGap: 16,
                          flexDirection: "column",
                        }}
                      >
                        {fields.map(({ key, name, ...restField }, index) => (
                          <Card
                            size="small"
                            title={
                              <RequiredLabel
                                text={`Day ${name + 1}`}
                                required={true}
                              />
                            }
                            key={key}
                            extra={
                              <Button
                                type="default"
                                shape="circle"
                                size="small"
                                icon={<DeleteOutlined />}
                                onClick={() => remove(name)}
                                disabled={fields?.length === 1}
                              />
                            }
                          >
                            <Form.Item
                              style={{ width: "100%" }}
                              {...restField}
                              name={[name, "day"]}
                              rules={[
                                {
                                  required: true,
                                  message: t(
                                    "Modules.Services.ServicesForm.pleaseSelectDay"
                                  ),
                                },
                              ]}
                            >
                              <Select
                                options={weekDaysData.filter(
                                  (element) =>
                                    !availability?.find(
                                      (_element) =>
                                        element?.value === _element?.day
                                    )
                                )}
                                placeholder={t(
                                  "Modules.Services.ServicesForm.selectDay"
                                )}
                              />
                            </Form.Item>

                            <Form.Item
                              {...restField}
                              label={
                                <RequiredLabel
                                  text={t(
                                    "Modules.Services.ServicesForm.startTime"
                                  )}
                                  required={true}
                                />
                              }
                              name={[name, "startTime"]}
                              rules={[
                                {
                                  required: true,
                                  message: t(
                                    "Modules.Services.ServicesForm.pleaseSelectStartTime"
                                  ),
                                },
                                {
                                  validator: (_, value) => {
                                    const currMinutes = new Date(
                                      value
                                    ).getMinutes();
                                    if (![0, 30].includes(currMinutes)) {
                                      return Promise.reject(
                                        t(
                                          "CommonUtils.PleaseSelectTimeWithMinutesInStepsOf30"
                                        )
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <TimePicker
                                defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                style={{ width: "100%" }}
                                use12Hours
                                format="h:mm a"
                                onKeyDown={(event) => event.preventDefault()}
                                disabledDate={(value) => {
                                  const currentTime = new Date(value).getTime();
                                  const allowedStartDate = new Date(
                                    availability[index]?.endTime
                                  ).getTime();
                                  return currentTime > allowedStartDate;
                                }}
                                showNow={false}
                                minuteStep={30}
                              />
                            </Form.Item>

                            <Form.Item
                              {...restField}
                              label={
                                <RequiredLabel
                                  text={t(
                                    "Modules.Services.ServicesForm.endTime"
                                  )}
                                  required={true}
                                />
                              }
                              name={[name, "endTime"]}
                              rules={[
                                {
                                  required: true,
                                  message: t(
                                    "Modules.Services.ServicesForm.pleaseSelectEndTime"
                                  ),
                                },
                                {
                                  validator: (_, value) => {
                                    const currMinutes = new Date(
                                      value
                                    ).getMinutes();
                                    if (![0, 30].includes(currMinutes)) {
                                      return Promise.reject(
                                        t(
                                          "CommonUtils.PleaseSelectTimeWithMinutesInStepsOf30"
                                        )
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <TimePicker
                                defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                style={{ width: "100%" }}
                                use12Hours
                                format="h:mm a"
                                onKeyDown={(event) => event.preventDefault()}
                                disabledDate={(value) => {
                                  const currentTime = new Date(value).getTime();
                                  const allowedEndDate = new Date(
                                    availability[index]?.startTime
                                  ).getTime();
                                  return currentTime < allowedEndDate;
                                }}
                                showNow={false}
                                minuteStep={30}
                              />
                            </Form.Item>
                          </Card>
                        ))}
                      </div>
                    </>
                  )}
                </Form.List>
                {/* form multiple list - availability */}

                {role &&
                role === userRoles.SERVICE_PROVIDER_ADMIN_ROLES.DOCTOR ? (
                  <Form.Item>
                    <Flex vertical gap="1rem">
                      <Flex gap="0.2rem" align="center">
                        <Title level={4}>
                          {t("Modules.Staff.StaffForm.uploadDocuments")}
                        </Title>
                        <Tooltip
                          placement="topLeft"
                          title={t("CommonUtils.multiplePdfDocumentsTooltip")}
                          color={colors.DarkMint}
                        >
                          <Button type="text" shape="circle" size="small">
                            <Flex align="center" justify="center">
                              <InfoButtonIcon />
                            </Flex>
                          </Button>
                        </Tooltip>
                      </Flex>
                      <Flex vertical align="center" justify="center">
                        <Upload
                          listType="picture-card"
                          fileList={multipleAttachmentList}
                          multiple
                          onPreview={handleAttachmentPreview}
                            onChange={(options) => {
                              const tempFileTypeIsValidResArr = options?.fileList?.map((element) => checkIfFileTypeIsValidForAllAttachment(element.name));
                              
                              const isValid = !tempFileTypeIsValidResArr.some((element) => element.isValid === false);
                              const fileTypeIsValidRes = tempFileTypeIsValidResArr.find((element) => element.isValid === false);
        
                              if (isValid === false) {
                                toastService.error(fileTypeIsValidRes.isInvalidMessage);
                              } else {
                                setMultipleAttachmentList(options.fileList);
                              }
                            }}
                          onRemove={(file) =>
                            setMultipleAttachmentList(
                              multipleAttachmentList?.filter(
                                (element) => element.uid !== file.uid
                              )
                            )
                          }
                          customRequest={(options) => {
                            const attachmentFileName = options.file.name;
                            const fileTypeIsValidRes = checkIfFileTypeIsValidForAllAttachment(attachmentFileName);

                            if (fileTypeIsValidRes.isValid === false) {
                              toastService.error(fileTypeIsValidRes.isInvalidMessage);
                            } else {
                              const formData = new FormData();
                              if(IMG_EXTENSION_ARR.includes(fileTypeIsValidRes.fileExtension)) {
                                formData.append("images", options.file);
                              }
                              else if(DOCUMENT_EXTENSION_ARR.includes(fileTypeIsValidRes.fileExtension)){
                                formData.append("documents", options.file);
                              }
                            dispatch(fileUploadAction(formData)).then(
                              (apiRes) => {
                                console.log(apiRes,'apiRes')
                                let response = apiRes;
                                let url = "";
                                if(apiRes?.documents?.length > 0) {
                                  response = apiRes?.documents[0];
                                  url = apiRes?.documents[0]?.documentUrl;
                                }
                                else if(apiRes?.images?.length > 0){
                                  response = apiRes?.images[0];
                                  url = apiRes?.images[0]?.url;
                                }
                                options.file["url"] = url;
                                options.onSuccess(response, options.file);
                              }
                            );
                            }
                          }}
                          className="uploadContainer"
                        >
                          <Button
                            type="primary"
                            shape="circle"
                            size="middle"
                            icon={<PaperClipOutlined />}
                          />
                        </Upload>
                        <Modal
                          open={openPreviewDialog}
                          title={previewTitle}
                          footer={null}
                          onCancel={() => setOpenPreviewDialog(false)}
                        >
                          <img
                            style={{ width: "100%" }}
                            src={previewImageSrc}
                          />
                        </Modal>
                      </Flex>
                    </Flex>
                  </Form.Item>
                ) : (
                  <></>
                )}

                <Form.Item
                  name="category"
                  label={
                    <RequiredLabel
                      text={t("Modules.Staff.StaffForm.category")}
                      required={true}
                    />
                  }
                  rules={[
                    {
                      required: true,
                      message: t(
                        "Modules.Staff.StaffForm.pleaseSelectCategory"
                      ),
                    },
                  ]}
                >
                  <Select
                    loading={selectListLoader}
                    options={categoriesSelectList?.filter(
                      (item) => item.is_active
                    )}
                    placeholder={t("Modules.Staff.StaffForm.selectCategory")}
                    onChange={onCategoryChanged}
                  />
                </Form.Item>
                {category && category !== null && category !== undefined ? (
                  <Form.Item
                    name="subCategories"
                    label={
                      <RequiredLabel
                        text={t("Modules.Staff.StaffForm.subCategory")}
                        required={true}
                      />
                    }
                    rules={[
                      {
                        required: true,
                        message: t(
                          "Modules.Staff.StaffForm.pleaseSelectSubCategory"
                        ),
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      options={subCategoriesSelectList}
                      placeholder={t(
                        "Modules.Staff.StaffForm.selectSubCategory"
                      )}
                    />
                  </Form.Item>
                ) : (
                  <></>
                )}

                <Form.Item
                  label={
                    <RequiredLabel
                      text={t("Modules.Staff.StaffForm.fees")}
                      required={true}
                    />
                  }
                  name="fees"
                  rules={[
                    {
                      required: true,
                      message: t("Modules.Staff.StaffForm.pleaseEnterFees"),
                    },
                    {
                      validator: (_, value) => {
                        if (value && value < 1)
                          return Promise.reject(
                            `${t("Modules.Staff.StaffForm.fees")} ${t(
                              "CommonUtils.shouldBeGreaterThan0"
                            )}`
                          );
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    type="number"
                    placeholder={t("Modules.Staff.StaffForm.enterFees")}
                    onKeyDown={allowCharactersOnlyForDecimalNumbers}
                    onWheel={disableOnWheel}
                  />
                </Form.Item>

                <Form.Item
                  label={
                    <RequiredLabel
                      text={t("Modules.Staff.StaffForm.experience")}
                      required={true}
                    />
                  }
                  name="experience"
                  rules={[
                    {
                      required: true,
                      message: t(
                        "Modules.Staff.StaffForm.pleaseEnterExperience"
                      ),
                    },
                    {
                      validator: (_, value) => {
                        if (value && value < 1)
                          return Promise.reject(
                            `${t("Modules.Staff.StaffForm.experience")} ${t(
                              "CommonUtils.shouldBeGreaterThan0"
                            )}`
                          );
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    type="number"
                    placeholder={t("Modules.Staff.StaffForm.enterExperience")}
                    onKeyDown={allowCharactersOnlyForDecimalNumbers}
                    onWheel={disableOnWheel}
                  />
                </Form.Item>

                {!selectedStaffId ? (
                  <Form.Item
                    label={
                      <RequiredLabel
                        text={t("SignIn.passwordLabel")}
                        required={true}
                      />
                    }
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: t("SignIn.passwordErrorMessage"),
                      },
                      {
                        validator: (_, value) => {
                          if (value && /\s/.test(value))
                            return Promise.reject(
                              t("SignIn.passwordNoSpaceErrorMessage")
                            );
                          return Promise.resolve();
                        },
                      },
                      {
                        pattern: appConstConfig.PASSWORD_VALIDATION_REGEX,
                        message: t("CommonUtils.invalidPassword"),
                      },
                    ]}
                    normalize={(value) => sanitizeDataTypeClientSide(value)}
                  >
                    <Input.Password
                      placeholder={t("SignIn.passwordPlaceholder")}
                      iconRender={(visible) =>
                        visible ? (
                          <EyeTwoTone style={{ fontSize: 16 }} />
                        ) : (
                          <EyeInvisibleOutlined style={{ fontSize: 16 }} />
                        )
                      }
                    />
                  </Form.Item>
                ) : (
                  <></>
                )}

                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                  loading={loading}
                  disabled={loading}
                >
                  {`${
                    selectedStaffId
                      ? t("Modules.Staff.StaffForm.editStaff")
                      : t("Modules.Staff.StaffForm.addStaff")
                  }`}
                </Button>
              </Flex>
            </Form>
          </Col>
          <Col span={10}>
            <Flex vertical gap="2rem" align="center">
              <Flex
                vertical
                align="center"
                justify="center"
                style={{ position: "relative" }}
              >
                <FileAttachment
                  attachmentObj={singleAttachmentObj}
                  attachmentUrl={singleAttachmetSelectedImageUrl}
                  loading={imageLoader}
                />

                <div
                  className="attachmentContainer"
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    bottom: "-25px",
                    background:colors.turquoiseGreen,
                    borderRadius:10,
                  }}
                  onClick={() => attachmentRef.current?.click()}
                >
                  <Button
                    type="primary"
                    shape="circle"
                    size="middle"
                    style={{ background:colors.turquoiseGreen}}
                    icon={<CameraOutlined style={{ fontSize: "22px" }} />}
                  />
                </div>

                <input
                  type="file"
                  style={{ display: "none" }}
                  ref={attachmentRef}
                  accept="image/*"
                  onChange={onImageChanged}
                />
              </Flex>
              <Typography.Title
                level={3}
                type="secondary"
                style={{ marginBottom: 10 }}
              >
                {t("CommonUtils.supportedImageFormats")}
              </Typography.Title>
            </Flex>
          </Col>
        </Row>
      </Flex>
    </div>
  );
};

export default StaffForm;
